import { memo, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { DropdownList, ListClose } from './verticalDot.style';
import CheckPermissions from '../../utils/permission/checkPermission';
import Spinners from '../spinner/index';
import { usePopper } from 'react-popper';
import AnimationWrapper from '../animation/animationWrapper';
import ActionAnimation from '../animation/action';
import clsx from 'clsx';
import { Placement } from '@popperjs/core';

export interface PopperContainerType {
  actions?: any[];
  id: string | number | undefined;
  rowData?: Record<string, string>;
  referenceElement?: any;
  show: boolean;
  counter?: number;
  handleShow: (value?: boolean) => void;
  doubleTable?: boolean;
  className?: string;
  renderPopoverInPortal?: boolean;
}

export const Portal = ({ children }: any): JSX.Element => {
  return createPortal(children, document.body);
};

const PopperContainer = ({
  actions,
  id,
  rowData,
  referenceElement,
  show,
  counter,
  handleShow,
  doubleTable = false,
  className,
  renderPopoverInPortal,
}: PopperContainerType): JSX.Element => {
  const [popperElement, setPopperElement] = useState<any>();
  const [visible, setVisibility] = useState(show);
  const { styles, attributes } = usePopper(referenceElement.current, popperElement, {
    // placement: 'bottom-start',
    placement: 'bottom-end',
    // modifiers: [
    //   {
    //     name: 'offset',
    //     options: {
    //       offset: [0, 8],
    //     },
    //   },
    //   {
    //     name: 'flip',
    //     enabled: true,
    //     options: {
    //       fallbackPlacements: ['top', 'bottom', 'right', 'left'], // by default, all the placements are allowed
    //     },
    //   },
    //   {
    //     name: 'preventOverflow',
    //     enabled: true,
    //     options: {
    //       rootBoundary: 'viewport', // This is important!
    //       padding: 8, // Optional: add some padding from the edge
    //     },
    //   },
    // ],
  });

  useEffect(() => {
    setVisibility(show);
  }, [show]);

  useEffect(() => {
    function handleClickOutside(event: Event): void {
      if (
        Boolean(popperElement) &&
        !(popperElement as HTMLElement).contains(event.target as Node)
      ) {
        setVisibility(false);
        handleShow(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popperElement]);

  // Generate test IDs following established patterns
  const popperContainerId = `actionsPopover.${counter}`;
  const actionsListId = `actionsList.${counter}`;
  const actionsCloseId = `actionsClose.${counter}`;

  return (
    <Portal>
      <AnimationWrapper>
        {visible && (
          <div
            id={popperContainerId}
            className={clsx(
              doubleTable ? 'testDrop' : renderPopoverInPortal ? 'z-1000' : 'z-10',
              className
            )}
            ref={setPopperElement}
            // style={styles.popper}
            style={{
              ...styles.popper,
              zIndex: renderPopoverInPortal && 2000,
            }}
            {...attributes.popper}>
            <DropdownList>
              <ActionAnimation className='dropdown'>
                <ListClose
                  id={actionsCloseId}
                  onClick={() => {
                    handleShow();
                  }}
                  className='cursor-pointer'>
                  <span className='material-symbols-outlined'>close</span>
                </ListClose>
                <ul id={actionsListId}>
                  {actions?.map((action, index) => (
                    <>
                      <CheckPermissions type={action.as} urlName={action.hasId}>
                        {action.loading === true ? (
                          <li
                            key={`actionItem.${index}`}
                            id={action?.id ?? `actionItem.${index}`}
                            className={'loader-wrapper'}>
                            <Spinners size='sm' />
                          </li>
                        ) : (
                          <li
                            key={`actionItem.${index}`}
                            id={action?.id ?? `actionItem.${index}`}
                            onClick={() => action.onClick(id, rowData)}>
                            {action.action}
                          </li>
                        )}
                      </CheckPermissions>
                    </>
                  ))}
                </ul>
              </ActionAnimation>
            </DropdownList>
          </div>
        )}
      </AnimationWrapper>
    </Portal>
  );
};

export default memo(PopperContainer);